module.exports = __webpack_public_path__ + "static/media/aws-sns-logo.4d8ee027.png";